import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  title = 'pulse';

  constructor(private translate: TranslateService) {
    const userLanguage = localStorage.getItem('ppuLanguagePreference');
    translate.setDefaultLang(userLanguage ?? 'en');    
    translate.use(userLanguage ?? (translate.getBrowserLang() || 'en'));
  }
}
